import { useEffect } from 'react';
/// Components
import Index from './jsx/index';
import Login from '../../pages/admin/Login';
import SignUp from './jsx/pages/Registration';
import ForgotPassword from './jsx/pages/ForgotPassword';
import { connect, useDispatch } from 'react-redux';
import {  Route, Routes, useLocation , useNavigate , useParams } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
// Hooks
import { useInactivityDetector } from './hooks/useInactivityDetector';
// Theme Context
import ThemeContextProvider from './context/ThemeContext';
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
      let location = useLocation();
      let navigate = useNavigate();
      let params = useParams();
      
      return (
        <Component
          {...props}
          router={{ location, navigate, params }}
        />
      );
    }
  
    return ComponentWithRouterProp;
}

function App (props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    
    // Pages où le détecteur d'inactivité doit être désactivé
    const authPages = ['/login', '/page-register', '/page-forgot-password', '/'];
    const isAuthPage = authPages.includes(location.pathname);
    
    // Détecteur d'inactivité - désactivé sur les pages d'authentification
    // Nettoie automatiquement le localStorage et force la reconnexion
    useInactivityDetector(15 * 60 * 1000, !isAuthPage);
    
    useEffect(() => {
        checkAutoLogin(dispatch, navigate);
    }, [dispatch, navigate]);
    
    // Debug logging
    console.log('Admin App - isAuthenticated:', props.isAuthenticated);
    console.log('Admin App - props:', props);
    
    let routeblog = (  
        <Routes>
            <Route path='/*' element={<Login />} />
            <Route path='/login' element={<Login />} />
            <Route path='/page-register' element={<SignUp />} />
            <Route path='/page-forgot-password' element={<ForgotPassword />} />
        </Routes>
    );
    
    if (props.isAuthenticated) {
		return (
            <ThemeContextProvider>
                <Index />
            </ThemeContextProvider>
        );
	} else {
		return (
			<div className="vh-100">
                {routeblog}
			</div>
		);
	}
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App)); 